import React from "react";

const AmountDepositedIcon = ({ width, height, color }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill={color || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="6" fill="url(#paint0_linear_520_639)" />
      <path
        d="M30 10L19 21"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 10L23 30L19 21L10 17L30 10Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_520_639"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAE99" />
          <stop offset="1" stopColor="#E23001" stopOpacity="0.94" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AmountDepositedIcon;
